import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { UsersService } from '../../services/users.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { FormBuilder } from '@angular/forms';
import { MessagePopupComponent } from '../../modals/message-popup/message-popup.component';

@Component({
  selector: 'app-verify',
  standalone: false,
  templateUrl: './verify.component.html',
  styleUrl: './verify.component.scss',
})
export class VerifyComponent implements OnInit {
  role: string;
  token: string;

  isError = false;
  isErrorText = 'something-went-wrong';
  isLoading = false;

  constructor(
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private usersService: UsersService,
    private modalService: BsModalService,
    private fb: FormBuilder,
  ) {}

  ngOnInit() {
    const user = this.authenticationService.userValue;
    if (user) {
      this.router.navigate(['/dashboard']);
    }
    this.isError = false;
    this.isErrorText = 'something-went-wrong';

    // get role from path
    this.role = this.route.snapshot.params['role'];
    // get token from path
    this.token = this.route.snapshot.params['token'];

    this.verifyAccount();
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }

  goBack() {
    this.location.back();
  }

  async verifyAccount() {
    this.isError = false;
    this.isErrorText = 'something-went-wrong';

    this.isLoading = true;
    this.usersService.verifyAccount(this.role, this.token).subscribe(
      async (response) => {
        console.log('response:');
        console.log(response);

        this.isError = false;
        this.isLoading = false;
        this.isErrorText = 'something-went-wrong';
        let modal = this.modalService.show(MessagePopupComponent, {
          initialState: {
            title: 'account-verified',
            text: 'account-verified-text',
            buttonText: 'okay',
          },
          class: 'alert-modal modal-dialog-centered',
          backdrop: 'static',
        });
        modal.onHidden.subscribe(() => {
          if (this.role == 'business') {
            this.goToLogin();
          } else {
            this.isError = true;
            this.isErrorText = 'return-back-to-mobile-app';
          }
        });
      },
      (error) => {
        console.log('error:');
        console.log(error);
        this.isError = true;
        this.isLoading = false;
        this.isErrorText = 'something-went-wrong';
      },
    );
  }
}
